import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { Skeleton } from '@chakra-ui/react';
import { ComboboxItem, ComboboxTagInput } from '@src/components/sco/ComboboxTagInput';
import { ScoIndustry } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React, { useEffect, useState } from 'react';
export const CompanyIndustryTagInput = props => {
  const $ = _c(23);
  let t0;
  if ($[0] !== props.defaultValue) {
    t0 = props.defaultValue || [];
    $[0] = props.defaultValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [value, setValue] = useState(t0);
  useState("");
  let t1;
  if ($[2] !== props || $[3] !== value) {
    t1 = () => {
      props.onChange(value);
    };
    $[2] = props;
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== value) {
    t2 = [value];
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = gql`
      {
        scoIndustries {
          id
          title
          key
        }
      }
    `;
    t4 = {
      ssr: false
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t3 = $[7];
    t4 = $[8];
  }
  const query = useQuery(t3, t4);
  let t5;
  if ($[9] !== query.data?.scoIndustries) {
    t5 = query.data?.scoIndustries || [];
    $[9] = query.data?.scoIndustries;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const options = t5;
  if (query.loading) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <Skeleton borderRadius="0.25em" height="2.5em" width="full" css={{
        "--start-color": "blackAlpha.300",
        "--end-color": "blackAlpha.500"
      }} />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  let t6;
  if ($[12] !== props.defaultValue) {
    t6 = props.defaultValue || [];
    $[12] = props.defaultValue;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = t6.map(_temp);
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {};
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== options) {
    t9 = options.map(_temp2);
    $[17] = options;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = values => {
      setValue(values.map(_temp3));
    };
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t7 || $[21] !== t9) {
    t11 = <ComboboxTagInput allowMultipleSelections={true} defaultSelectedItems={t7} inputProps={t8} items={t9} onChange={t10} />;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(key) {
  return {
    key,
    title: key
  };
}
function _temp2(industry) {
  return {
    key: industry.key,
    title: industry.title
  };
}
function _temp3(v) {
  return v.key;
}